<script lang="ts">
	import { icons } from '$lib/config/svg-base';
	import { technologyIcons } from '$lib/config/svg-technologyIcons';
	
  export let data;
  const itemIcon = data ? icons[data.iconName] : null;
</script>

<div class="stack-list-item">
	<div class="top flex-column-center">
		{@html itemIcon}
		<h3>{@html data.title}</h3>
	</div>
	<div class="bottom flex-row">
		{#each data.stack as stackItem}
			<div class="icon-block flex-column">
				<a href="{stackItem.url}">
					{@html technologyIcons[stackItem.iconName]}
					<h4>
						{stackItem.title}
					</h4>
				</a>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
  @import '$styles/vars';

  .stack-list-item {
    .top {
      border-radius: 12px 12px 0 0;
      background: rgba(255, 255, 255, 0.05);
      text-align: center;
      row-gap: 24px;
      padding-top: 36px;
      padding-bottom: 36px;
      backdrop-filter: blur(12px);
    }

    .bottom {
      margin-top: 2px;
      border-radius: 0 0 12px 12px;
      background: rgba(255, 255, 255, 0.05);
      backdrop-filter: blur(12px);
      justify-content: space-around;
      align-items: center;
      height: 130px;
      min-height: 130px;

      .icon-block {
        align-items: center;
        text-align: center;
        flex: 1 1 100%;
				a {
					color: $main-white;
		
					&:hover {
						h4 {
							text-decoration: underline;
						}
					}
				}

        h4 {
          margin-top: 12px;
          font-size: 14px;
          font-weight: 300;
        }
      }
    }
  }

  @media (max-width: $portrait-phone-size) {
    .stack-list-item {
      .top {
        padding-top: 24px;
        padding-bottom: 24px;
        box-sizing: border-box;
        font-size: 18px;
        row-gap: 12px;
      }

      .bottom {
        min-height: unset;
        height: unset;
        justify-content: center;
        padding-top: 24px;
        padding-bottom: 24px;

        .icon-block {
          h4 {
            font-size: 14px;
          }
        }
      }
    }
  }

</style>
